import { Component, inject, Injectable } from '@angular/core';
import { Route, Router, Routes } from '@angular/router';
import { ShellComponent } from '@shell/shell.component';

export class ShellOptions {
  path?: string;
  component?: any;
  guards?: any[];
  reuse?: boolean;
  pathMatch?: 'full' | 'prefix' | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class Shell {
  static childRoutes(routes: Routes, options?: ShellOptions): Route {
    return {
      path: options?.path || '',
      component: options?.component || ShellComponent,
      children: routes,
      canActivate: options?.guards || [],
      //pathMatch: options?.pathMatch,

      data: { reuse: options?.reuse && true },
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class ShellService {
  private readonly router = inject(Router);
}
